import { configureStore } from '@reduxjs/toolkit';
import callReducer from './slices/callSlice';
import themeReducer from './slices/themeSlice';

export const store = configureStore({
  reducer: {
    call: callReducer,
    theme: themeReducer,
  },
});
